<template>
    <div class="aside-cms">
        <el-row class="cms-nav-header">
            <el-col :span="12">
                <div class="cms-nav-title">เนื้อหา</div>
            </el-col>
            <el-col :span="12">
                <div style="font-size:22px;text-align:right;">
                    <template v-if="disabledSortMenu">
                        <el-button type="text" class="edit-btn" @click="disabledSortMenu = false">
                            <fa-icon name="pen"></fa-icon>
                        </el-button>
                    </template>
                    <template v-else>
                        <el-button type="text" class="check-btn" @click="saveSortMenu">
                            <fa-icon name="check"></fa-icon>
                        </el-button>
                        <el-button type="text" class="close-btn" @click="cancleSortMenu">
                            <fa-icon name="times"></fa-icon>
                        </el-button>
                    </template>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col class="cms-nav-content" :span="24">
                <draggable
                    class="list-group"
                    tag="ul"
                    v-model="textContentDetail.titleList"
                    v-bind="dragOptions"
                    @start="drag = true"
                    @end="drag = false"
                >
                    <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                        <li
                            class="list-group-item"
                            :class="{'cursorMove': !disabledSortMenu}"
                            v-for="(element) in textContentDetail.titleList"
                            :key="element.learningCenterId"
                        >
                            <i
                                :class="element.fixed ? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'"
                                aria-hidden="true"
                                @click="element.fixed = !element.fixed"
                            ></i>
                                <span
                                    class="title-text"
                                    :class="{
                                        'title-text-active':textContentDetail.detail.learningCenterId === element.learningCenterId,
                                        'grey--text':!element.isPublish&&textContentDetail.detail.learningCenterId !== element.learningCenterId
                                    }"
                                    @click="selectContentTitle(element)"
                                >
                                    {{ element.title }}
                                </span>
                            <ul v-if="textContentDetail.detail.learningCenterId === element.learningCenterId">
                                <li
                                    v-for="(subElement, idx) in element.subTitle"
                                    :key="subElement.id"
                                    class="subtitle"
                                    :class="{'subtitle-text-disable':!disabledSortMenu}"
                                    :disabled="!disabledSortMenu">
                                    <span
                                        class="subtitle-text"
                                        :class="{
                                            'subtitle-title-text-active':textContentDetail.subTitleDetail.id === idx,
                                            'grey--text':!element.isPublish
                                        }"
                                        @click="selectContentSubTitle(subElement,idx)"
                                    >
                                        {{ subElement.text|removeTag }}
                                    </span>
                                </li>
                            </ul>
                        </li>
                    </transition-group>
                </draggable>
                <el-button class="add-content-btn" @click="addNewTextContent"><i class="el-icon-plus"></i></el-button>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import fgApi from '@/services/fillgoods'
import learningCenter from '@/components/LearningCenter/mixins/learningCenter.js'
import draggable from 'vuedraggable'
export default {
    name: 'LearningCenterNavMenu',
    filters: {
        removeTag (val) {
            return val.replace(/<\/?[^>]+(>|$)/g, '')
        }
    },
    components: {
        draggable
    },
    mixins: [learningCenter],
    props: {
        textContentDetail: {
            type: Object,
            default: () => {
                return {
                    titleList: [],
                    detail: {},
                    subTitleDetail: {
                        id: '',
                        text: ''
                    }
                }
            }
        }
    },
    data () {
        return {
            drag: false,
            disabledSortMenu: true
        }
    },
    computed: {
        dragOptions () {
            return {
                animation: 200,
                group: 'description',
                disabled: this.disabledSortMenu,
                ghostClass: 'ghost'
            }
        }
    },
    created () {
        this.fetchAllContentTitle()
    },
    methods: {
        async fetchAllContentTitle () {
            this.$loading()
            this.textContentDetail.titleList = await this.getAllContentTitle()
            this.$loading().close()
        },
        async saveSortMenu () {
            try {
                this.$loading()
                let param = {
                    learningCenterIds: this.textContentDetail.titleList.map(e => {
                        return e.learningCenterId
                    })
                }
                let res = await fgApi.cms.reorderLearningContent(param)
                if (res.success) {
                    this.notifyLearningCenter('Edit sort title success', 'success')
                } else {
                    this.notifyLearningCenter('Edit sort title fail', 'error')
                }
                this.disabledSortMenu = true
            } catch (error) {
                this.notifyLearningCenter(error, 'error')
            }
            this.$loading().close()
        },
        async cancleSortMenu () {
            this.$loading()
            this.textContentDetail.titleList = await this.getAllContentTitle()
            this.disabledSortMenu = true
            this.$loading().close()
        },
        async addNewTextContent () {
            try {
                this.$loading()
                let param = {
                    title: 'Untitle',
                    html: '<p></p>',
                    isPublish: false
                }
                let res = await fgApi.cms.createLearningContent(param)
                if (res.success) {
                    this.textContentDetail.titleList.push({ ...res.data, subTitle: [] })
                    this.textContentDetail.detail = { ...res.data }
                } else {
                    this.notifyLearningCenter('Create draft fail', 'error')
                }
            } catch (error) {
                this.notifyLearningCenter(error, 'error')
            }
            this.$loading().close()
        },
        async selectContentTitle (detail) {
            try {
                this.$loading()
                let res = await fgApi.cms.getLearningContentWithId(detail.learningCenterId)
                if (res.success) {
                    this.textContentDetail.detail = res.data
                    this.textContentDetail.titleList = await this.filterSubTitleFormHtmlTag(this.textContentDetail.detail)
                    this.textContentDetail.subTitleDetail = { id: '', name: '' }
                } else {
                    this.notifyLearningCenter('Get title by id fail', 'error')
                }
            } catch (error) {
                this.notifyLearningCenter(error, 'error')
            }
            this.$loading().close()
        },
        selectContentSubTitle (detail, index) {
            this.textContentDetail.subTitleDetail.id = index
            this.textContentDetail.subTitleDetail.text = detail
        }
    }
}
</script>

<style lang="scss">
.cms-notify-style{
    background-color: #000;
    p{
        color: #AAC27F !important;
    }
}
.aside-cms {
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    padding:19px 32px 0px;
    min-height:100%;
    .cms-nav-header{
        display: flex;
        align-items: center;
    }
    .cms-nav-content{
        text-align:left;
        padding-bottom: 12px;
    }
    .cms-nav-title{
        text-align:left;
        font-size:22px;
        font-weight: 400;
    }
    .title-text{
        font-family: 'Kanit';
        font-size: 16px;
        font-weight: 400;
        color: #000000DE;
        cursor: pointer;
        span{
            display: inline-block;
            max-width: 250px !important;
            word-break: break-all;
        }
    }
    .edit-btn{
        color: #00000080;
    }
    .check-btn{
        color: #1D8649;
    }
    .close-btn{
        color: #FF002E;
    }
    .title-text-active{
        color: #1D8649;
    }
    .subtitle{
        display: block;
        padding-top: 5px;
    }
    .grey--text{
        color: rgba(0,0,0,0.62) !important;
    }
    .subtitle-text{
        font-family: 'Kanit';
        font-size: 14px;
        font-weight: 300;
        color: #000000DE;
        cursor: pointer;
    }
    .subtitle-title-text-active{
        color: #1D8649;
    }
    .add-content-btn{
        width:100%;
        height: 30px;
        padding: 0;
    }
}
</style>

<style lang="scss">
.subtitle-text-disable{
    pointer-events: none;
}
.flip-list-move {
    transition: transform 0.5s;
}
.no-move {
    transition: transform 0s;
}
.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}
.list-group {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-direction: column;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 10px;
    min-height: 20px;
}
.list-group-item {
    position: relative;
    display: block;
    padding: .75rem 1.25rem;
    margin-bottom: -1px;
    background-color: #fff;
}
.cursorMove {
    border: 1px solid rgba(0,0,0,.125);
    cursor: move;
}
.list-group-item i {
    cursor: pointer;
}
</style>
